import { render, staticRenderFns } from "./MedicalTrendStatistics.vue?vue&type=template&id=23696259&"
import script from "./MedicalTrendStatistics.vue?vue&type=script&lang=js&"
export * from "./MedicalTrendStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MedicalTrendStatistics.vue?vue&type=style&index=0&id=23696259&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23696259')) {
      api.createRecord('23696259', component.options)
    } else {
      api.reload('23696259', component.options)
    }
    module.hot.accept("./MedicalTrendStatistics.vue?vue&type=template&id=23696259&", function () {
      api.rerender('23696259', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/medicaltrend/MedicalTrendStatistics.vue"
export default component.exports